import NotImplementedError from "./NotImplementedError.js";

/**
 *
 * @version 2026-09-01
 * @author Patrik Harag
 */
export default class NotificationProvider {
    handleError(title, e) {
        throw new NotImplementedError();
    }

    handleInfo(title, description) {
        throw new NotImplementedError();
    }
}